import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { items, RequestsListViewModel } from "./requestsList-viewModel"

export class RequestsListView extends View<RequestsListViewModel>{
    GetViewUniqueId(): string {
        return "V-B14FE4E1-5069-42AF-B45F-CDFF0CB9EF2D"
    }
    loadHtml(): string {
        let element = require('./requestsList.html').default;
        let style = require('./requestsList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set rows(v: ObservableArray<items>) { this._rows = v; } public get rows(): ObservableArray<items> { return this._rows;} private _rows: ObservableArray<items>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    public set canExportExcel(v: boolean) { this._canExportExcel = v; } public get canExportExcel(): boolean { return this._canExportExcel;} private _canExportExcel: boolean;

    exportExcel(){
        this.dataContext.exportExcel();
    }
}
